import React, { useState } from 'react';

import { formatCurrencyAmountSimple } from 'src/helpers/formatting';
import { DateTime } from 'luxon';
import { StatusSpan } from 'src/components';

import './transaction-row.scss';
import TealiumEvents from 'src/helpers/tealium-events';
import { useSelectedTransactions } from 'src/hooks/use-selected-transaction';
import { TerminalTransaction } from 'src/common/types';

type TransactionRowProps = {
  transactions: TerminalTransaction[];
  settlementTransaction: TerminalTransaction;
};

export default function TransactionRow(props: TransactionRowProps) {
  const { setSelectedTransaction } = useSelectedTransactions();
  const [expanded, setExpanded] = useState(false);

  const displayIncrements = 6;
  const [displayedAmount, setDisplayedAmount] = useState(displayIncrements);

  return (
    <>
      {props.transactions && (
        <>
          <tr
            onClick={() => {
              TealiumEvents.accountTransactionsClickViewMoreTransactions();
              setExpanded(!expanded);
            }}
            className={`TransactionRow main-row ${expanded ? 'is-expanded' : ''}`}
          >
            {!!props.settlementTransaction.processingDate && (
              <td>
                {DateTime.fromISO(props.settlementTransaction.processingDate).toFormat(
                  'dd MMMM yyyy',
                )}
              </td>
            )}

            <td>R {formatCurrencyAmountSimple(props.settlementTransaction.transactionAmount)}</td>
            <td>
              <span
                className={`icon-chevron-${
                  expanded ? 'up' : 'down'
                }-thin is-icon-4 has-text-grey-light is-pulled-right has-margin-right-7`}
              ></span>
            </td>
          </tr>
          {expanded && (
            <tr className="TransactionRow sub-row">
              <td className="sub-table-container" colSpan={5}>
                <table className="table is-fullwidth sub-table">
                  <thead>
                    <tr>
                      <th>Transaction type</th>
                      <th>Ref. no.</th>
                      <th>Time</th>
                      <th>Amount</th>
                      <th>Response code</th>
                      <th className="has-text-right">Details</th>
                    </tr>
                  </thead>
                  <tbody>
                    {props.transactions &&
                      props.transactions.slice(0, displayedAmount).map((transaction, tIndex) => {
                        return (
                          <tr key={tIndex}>
                            <td>{transaction.transactionTypeDescription}</td>
                            <td>{transaction.retrievalReferenceNumber}</td>
                            <td>
                              {DateTime.fromISO(transaction.transactionDate).toFormat('HH:mm')}
                            </td>
                            <td>R {formatCurrencyAmountSimple(transaction.transactionAmount)}</td>
                            <td>
                              <StatusSpan status={transaction.responseCodeClassifier} />
                            </td>
                            <td>
                              <span
                                className="icon-chevron-right-thin is-icon-4 has-text-grey-light is-pulled-right"
                                onClick={() => {
                                  TealiumEvents.accountTransactionsClickViewIndividualTransaction();
                                  setSelectedTransaction(transaction);
                                }}
                              ></span>
                            </td>
                          </tr>
                        );
                      })}
                    {displayedAmount < props.transactions.length && (
                      <tr>
                        <td colSpan={7} className="has-text-centered">
                          <div
                            className="load-more-container"
                            onClick={() => {
                              const newDisplayedAmount = Math.min(
                                displayedAmount + displayIncrements,
                                props.transactions.length,
                              );
                              setDisplayedAmount(newDisplayedAmount);
                            }}
                          >
                            Load more&nbsp;
                            <span className="icon icon-menu-chevron-down is-icon-7"></span>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </td>
            </tr>
          )}
        </>
      )}
    </>
  );
}
